import { Result } from 'journeys/portal/Forms/Sections.constants';
import { FoundResultF62SensorTrimNeedFormula, FoundResultAsFoundResultFormula } from './P63.formulas';

export const FoundResultSectionDataP63 = (selectedTag, formData) => ({
    rows: [{
        key: 1,
        fields: [{
            key: 'F60ToleranceEuLabel',
            value: 'Tolerance (EU)',
            xs: 2,
            width: '100%',
            readOnly: true,
            labelWidth: '0',
            height: '1.1rem',
            borderRight: '0',
            borderBottom: '0',
            marginLeft: '0.26rem',
            borderLeft: '0',
            isLabelNew: true,
            marginBottom: '4px'
        },
        {
            key: 'F101AftTolerance',
            value: selectedTag.DateTested ? formData?.F101AftTolerance : formData?.F101AftTolerance ?? selectedTag?.ToleranceInInstrumentEu,
            maxLength: '10',
            type: 'number',
            xs: 2,
            width: '100%',
            labelWidth: '0',
            textAlign: 'center',
            height: '1.1rem',
            borderBottom: '0',
            isRequired: true
        },
        {
            key: 'F62SensorTrimNeedLabel',
            value: 'Sensor Trim Needed?',
            width: '100%',
            readOnly: true,
            labelWidth: '0',
            height: '1.1rem',
            xs: 2,
            isLabelBold: true,
            borderBottom: '0',
            borderRight: '0',
            borderLeft: '0',
            textAlign: 'end'
        },
        {
            key: 'F62SensorTrimNeed',
            value: FoundResultF62SensorTrimNeedFormula(formData),
            readOnly: true,
            isCalculatedNew: true,
            xs: 2,
            width: '100%',
            labelWidth: '0',
            textAlign: 'center',
            height: '1.1rem',
            inputMarginRight: '0',
            borderBottom: '0',
            borderRight: '0'
        },
        {
            key: 'F102AftResultLabel',
            value: Result.AS_FOUND_RESULT_LABEL,
            xs: 2,
            width: '100%',
            readOnly: true,
            labelWidth: '0',
            height: '1.1rem',
            borderRight: '0',
            borderBottom: '0',
            isLabelBold: true,
            marginBottom: '4px',
            textAlign: 'end'
        },
        {
            key: 'F102AftResult',
            value: FoundResultAsFoundResultFormula(formData),
            xs: 2,
            width: '100%',
            labelWidth: '0',
            isCalculatedNew: true,
            readOnly: true,
            textAlign: 'center',
            height: '1.1rem',
            borderBottom: '0',
            borderRight: '0',
            inputMarginRight: '4px',
        }]
    }]
});
